/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Selectors for Settings component
 *
 * @author Anton Panasenko
 * @version 1.3.0
 * @since 1.3.0
 */

import { createSelector, OutputSelector } from 'reselect';

import { IRootReducer } from '../../reducers/rootReducer';
import { ISettingsCommonReducer } from './PageSettingsTypes';

export const makeSelectSettingsCommonState = (state: IRootReducer): ISettingsCommonReducer =>
    state.settings.common;

/*
* -------------------------------------------
*           IS SHOW LOADER
* -------------------------------------------
*/

export const makeSelectSettingsIsShowLoader = ():
    OutputSelector<IRootReducer, boolean, (state: ISettingsCommonReducer) => boolean> =>
    createSelector(makeSelectSettingsCommonState, (state) => state.isShowLoading);
